var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group", class: { "with-error": _vm.error } },
    [
      _vm.error
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
      _vm._v(" "),
      !_vm.mask
        ? _c("input", {
            attrs: {
              id: _vm.id,
              type: _vm.type,
              disabled: _vm.disabled,
              placeholder: "."
            },
            domProps: { value: _vm.value },
            on: {
              keyup: [
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.$emit("keyupEnter")
                },
                function($event) {
                  _vm.$emit("keyup")
                }
              ],
              focus: function($event) {
                _vm.$emit("focus")
              },
              blur: function($event) {
                _vm.$emit("blur")
              },
              input: function($event) {
                _vm.$emit("input", $event.target.value)
              }
            }
          })
        : _c("the-mask", {
            attrs: {
              id: _vm.id,
              value: _vm.value,
              type: _vm.type,
              mask: _vm.mask,
              masked: _vm.masked,
              disabled: _vm.disabled,
              placeholder: "."
            },
            on: {
              keyup: [
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.$emit("keyupEnter")
                },
                function($event) {
                  _vm.$emit("keyup")
                }
              ],
              focus: function($event) {
                _vm.$emit("focus")
              },
              blur: function($event) {
                _vm.$emit("blur")
              },
              input: function($event) {
                _vm.$emit("input", $event)
              }
            }
          }),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4659b12b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4659b12b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_base/Input.vue
// module id = null
// module chunks = 